// extracted by mini-css-extract-plugin
module.exports = {"tableBody":"TableBody_tableBody__1tFxE"};